import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RadioButton = props => {
    //onBlur is not actually true while onClick, however, it triggers the inline validation once an option is selected.
    const onClick = (event) => {
        var _a, _b;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
        (_b = props.onBlur) === null || _b === void 0 ? void 0 : _b.call(props);
    };
    return (_jsxs("div", Object.assign({ className: "custom-control custom-radio custom-control-inline" }, { children: [_jsx("input", { type: "radio", id: props.id, checked: props.checked, onChange: props.onChange, className: "custom-control-input", onClick: onClick, onBlur: props.onBlur, disabled: props.disabled }), _jsx("label", Object.assign({ htmlFor: props.id, className: "custom-control-label" }, { children: props.label }))] })));
};
